import { useSelector } from 'react-redux';

export const useSettingsSelector = () => useSelector((state) => state.settings);
